


import { createAction as ngrxCreateAction, props, Action } from '@ngrx/store';

export const INIT_SCREEN = '[Master searchUser] Init';
export const DESTROY_SCREEN = '[Master searchUser] Destroy';


    export const EDITAR = '[Master searchUser] Editar';



export const COUNT = '[Master searchUser] Count';
export const COUNT_SUCCESS = '[Master searchUser] Count Success';
export const COUNT_FAIL = '[Master searchUser] Count Fail';
export const SEARCH = '[Master searchUser] Search';
export const SEARCH_SUCCESS = '[Master searchUser] Search Success';
export const SEARCH_FAIL = '[Master searchUser] Search Fail';
export const ROWS_SELECTION_CHANGE = '[Master searchUser] Rows Selection Change';


export const initAction = ngrxCreateAction(INIT_SCREEN, payload => payload);

export const destroyAction = ngrxCreateAction(DESTROY_SCREEN, payload => payload);

  // Editar action
export const editarAction = ngrxCreateAction(EDITAR,payload => payload);


// count action
export const countAction = ngrxCreateAction(COUNT,payload => payload);

export const countSuccessAction = ngrxCreateAction(COUNT_SUCCESS,payload => payload);

export const countFailAction = ngrxCreateAction(COUNT_FAIL,payload => payload);

// search action
export const searchAction = ngrxCreateAction(SEARCH,payload => payload);

export const searchSuccessAction = ngrxCreateAction(SEARCH_SUCCESS,payload => payload);

export const searchFailAction = ngrxCreateAction(SEARCH_FAIL,payload => payload);

export const rowsSelectionChangeAction = ngrxCreateAction(ROWS_SELECTION_CHANGE,payload => payload);




